var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"disabled":_vm.disabled || _vm.processing,"loading":_vm.loading && _vm.processing},on:{"click":_vm.handleClick}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }